import React from "react"
import Menu from "./Menu"
import Account from "./Account"
const Tabs = () => {
  const [openTab, setOpenTab] = React.useState(1)
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full">
          <ul className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row px-2">
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase rounded-sm px-5 border-b py-3 shadow-lg block leading-normal  " +
                  (openTab === 1
                    ? "text-white bg-black"
                    : "text-black bg-white ")
                }
                onClick={e => {
                  e.preventDefault()
                  setOpenTab(1)
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
                tabIndex={0}
              >
                Menu
              </a>
            </li>
            <li className="-mb-px mr-2  last:mr-0 flex-auto  text-center">
              <a
                className={
                  "text-xs font-bold uppercase rounded-sm px-5 py-3 shadow-lg block leading-normal  " +
                  (openTab === 2
                    ? "text-white bg-black"
                    : "text-black bg-white ")
                }
                onClick={e => {
                  e.preventDefault()
                  setOpenTab(2)
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                Account
              </a>
            </li>
          </ul>
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full  shadow-lg rounded h-screen">
            <div className="px-4 py-5 flex-auto">
              <div className="tab-content tab-space">
                <Menu openTab={openTab} />
                <Account openTab={openTab} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default function TabsRender() {
  return (
    <>
      <Tabs />
    </>
  )
}
